import { AbstractCommand } from './AbstractCommand';
import { CommandResponse } from '../types';
import { getSequenceId } from '../utils/sequenceIdManager';

export enum CameraOperation {
  RECORD = 'ipcam_record_set',
  TIMELAPSE = 'ipcam_timelapse',
  RESOLUTION = 'ipcam_resolution_set'
}

export class CameraControlCommand extends AbstractCommand {
  public readonly category = 'system';
  public readonly command: CameraOperation;

  constructor(
    operation: CameraOperation,
    private value: boolean | string
  ) {
    super();
    this.command = operation;
  }

  toJSON(): object {
    const base = {
      system: {
        command: this.command,
        sequence_id: getSequenceId().toString()
      }
    };

    if (this.command === CameraOperation.RESOLUTION) {
      return {
        ...base,
        system: {
          ...base.system,
          resolution: this.value
        }
      };
    }

    return {
      ...base,
      system: {
        ...base.system,
        control: typeof this.value === 'boolean' ? (this.value ? 'enable' : 'disable') : this.value
      }
    };
  }

  ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
    if (!('system' in response)) {
      return false;
    }

    const systemResponse = response as { system: { sequence_id?: string | undefined } };
    const responseId = systemResponse.system?.sequence_id;
    const extraId = this.extra?.sequence_id;

    if (!responseId) {
      return false;
    }

    if (sequence_id && responseId === sequence_id) {
      return true;
    }

    if (extraId && responseId === extraId) {
      return true;
    }

    return false;
  }
}